import { Link } from "gatsby"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { useHoverIntent } from "react-use-hoverintent"

import IconLink from "@atoms/IconLink/IconLink"
import { MotionBox } from "@atoms/MotionBox/MotionBox"
import iconShop from "@images/svg/shopping-cart.svg"
import iconUser from "@images/svg/user.svg"
import { useWindowWidth } from "@react-hook/window-size"

import styles from "./Menu.module.scss"

const Menu = ({ open, menuItems, currentLanguage, siteSettings }) => {
  const [delayLeave, setDelayLeave] = useState(false)
  const [openInProgress, setOpenInProgress] = useState(false)
  const [mobileSubOpen, setMobileSubOpen] = useState(null)

  useEffect(() => {
    if (!openInProgress) {
      let handler = null
      let progressHandler = null
      //let blockHandler = null
      if (open) {
        setOpenInProgress(true)
        progressHandler = setTimeout(() => setOpenInProgress(false), 300)
        setDelayLeave(true)
      } else {
        handler = setTimeout(() => setDelayLeave(false), 1000)
      }
      return () => {
        clearTimeout(handler)
        clearTimeout(progressHandler)
      }
    } else {
      // TODO: testaa miten käy, jos avaa ja sulkee navin sikanopeeta
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  const windowWidth = useWindowWidth()

  // Hover intent, voi pyhä isä

  const [isHovering0, ref0] = useHoverIntent()
  const [isHovering1, ref1] = useHoverIntent()
  const [isHovering2, ref2] = useHoverIntent()
  const [isHovering3, ref3] = useHoverIntent()
  const [isHovering4, ref4] = useHoverIntent()
  const [isHovering5, ref5] = useHoverIntent()
  const [isHovering6, ref6] = useHoverIntent()

  useEffect(() => {
    let item = menuItems[currentLanguage][0]
    if (windowWidth > 991 && isHovering0 && item) {
      if (item.childItems?.nodes.length > 0) {
        setMobileSubOpen(item.id)
      } else {
        setMobileSubOpen(null)
      }
    }
  }, [isHovering0, currentLanguage, windowWidth, menuItems, setMobileSubOpen])

  useEffect(() => {
    let item = menuItems[currentLanguage][1]
    if (windowWidth > 991 && isHovering1 && item) {
      if (item.childItems?.nodes.length > 0) {
        setMobileSubOpen(item.id)
      } else {
        setMobileSubOpen(null)
      }
    }
  }, [isHovering1, currentLanguage, windowWidth, menuItems, setMobileSubOpen])

  useEffect(() => {
    let item = menuItems[currentLanguage][2]
    if (windowWidth > 991 && isHovering2 && item) {
      if (item.childItems?.nodes.length > 0) {
        setMobileSubOpen(item.id)
      } else {
        setMobileSubOpen(null)
      }
    }
  }, [isHovering2, currentLanguage, windowWidth, menuItems, setMobileSubOpen])

  useEffect(() => {
    let item = menuItems[currentLanguage][3]
    if (windowWidth > 991 && isHovering3 && item) {
      if (item.childItems?.nodes.length > 0) {
        setMobileSubOpen(item.id)
      } else {
        setMobileSubOpen(null)
      }
    }
  }, [isHovering3, currentLanguage, windowWidth, menuItems, setMobileSubOpen])

  useEffect(() => {
    let item = menuItems[currentLanguage][4]
    if (windowWidth > 991 && isHovering4 && item) {
      if (item.childItems?.nodes.length > 0) {
        setMobileSubOpen(item.id)
      } else {
        setMobileSubOpen(null)
      }
    }
  }, [isHovering4, currentLanguage, windowWidth, menuItems, setMobileSubOpen])

  useEffect(() => {
    let item = menuItems[currentLanguage][5]
    if (windowWidth > 991 && isHovering5 && item) {
      if (item.childItems?.nodes.length > 0) {
        setMobileSubOpen(item.id)
      } else {
        setMobileSubOpen(null)
      }
    }
  }, [isHovering5, currentLanguage, windowWidth, menuItems, setMobileSubOpen])

  useEffect(() => {
    let item = menuItems[currentLanguage][6]
    if (windowWidth > 991 && isHovering6 && item) {
      if (item.childItems?.nodes.length > 0) {
        setMobileSubOpen(item.id)
      } else {
        setMobileSubOpen(null)
      }
    }
  }, [isHovering6, currentLanguage, windowWidth, menuItems, setMobileSubOpen])

  return (
    <div
      className={`${styles.nav} ${
        open || delayLeave ? styles.stateActive : ""
      }`}
      aria-expanded={open}
    >
      <MotionBox
        //animate={mobileOpen ? { opacity: 1, y: 0 } : { opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
      >
        <ul className={styles.list}>
          {menuItems[currentLanguage] &&
            menuItems[currentLanguage].map((item, index) => {
              let thisRef = null

              switch (index) {
                case 0:
                  thisRef = ref0
                  break
                case 1:
                  thisRef = ref1
                  break
                case 2:
                  thisRef = ref2
                  break
                case 3:
                  thisRef = ref3
                  break
                case 4:
                  thisRef = ref4
                  break
                case 5:
                  thisRef = ref5
                  break
                case 6:
                  thisRef = ref6
                  break
                default:
              }

              let refProps = thisRef ? { ref: thisRef } : false

              return (
                <li
                  className={item.cssClasses
                    .concat("menu-item another-menu-item-class")
                    .concat(
                      mobileSubOpen && mobileSubOpen !== item.id
                        ? styles.inactive
                        : ""
                    )
                    .concat(styles.listItem)
                    .join(" ")}
                  key={item.id}
                >
                  {item.childItems?.nodes.length === 0 && (
                    <Link
                      {...refProps}
                      //ref={thisRef}
                      to={item.url}
                      activeClassName={`${styles["state--active"]}`}
                      /*
                      onMouseOver={
                        windowWidth > 991
                          ? () => setMobileSubOpen(null)
                          : undefined
                      }
                      */
                    >
                      <span>{item.label}</span>
                    </Link>
                  )}
                  {item.childItems?.nodes.length > 0 && (
                    <section ref={thisRef}>
                      <button
                        aria-expanded={
                          mobileSubOpen === item.id ? "true" : "false"
                        }
                        className={styles.trigger}
                        /*
                        onMouseOver={
                          windowWidth > 991
                            ? () => setMobileSubOpen(item.id)
                            : undefined
                        }
                        */
                        onFocus={undefined}
                        onClick={() =>
                          setMobileSubOpen(
                            mobileSubOpen === item.id ? null : item.id
                          )
                        }
                      >
                        <span>{item.label}</span>
                      </button>

                      <ul>
                        {item.childItems.nodes.map((child) => {
                          return (
                            <li
                              className={child.cssClasses
                                .concat("submenu-item-level-2")
                                .join(" ")}
                              key={child.id}
                            >
                              {child?.url && child.url !== "#" && (
                                <Link
                                  to={child.url}
                                  activeClassName={`${styles["state--active"]}`}
                                >
                                  {child.label}
                                </Link>
                              )}
                              {(!child.url || child.url === "#") && (
                                <span className={styles.subHeading}>
                                  {child.label}
                                </span>
                              )}

                              {child.childItems?.nodes.length > 0 && (
                                <ul>
                                  {child.childItems.nodes &&
                                    child.childItems.nodes.map((child) => {
                                      const innerLink = child.url[0] === "/"

                                      return (
                                        <li
                                          className={child.cssClasses
                                            .concat("submenu-item-level-3")
                                            .join(" ")}
                                          key={child.id}
                                        >
                                          {innerLink && (
                                            <Link
                                              to={child.url}
                                              activeClassName={`${styles["state--active"]}`}
                                            >
                                              {child.label}
                                            </Link>
                                          )}
                                          {!innerLink && (
                                            <a href={child.url}>
                                              {child.label}
                                            </a>
                                          )}
                                        </li>
                                      )
                                    })}
                                </ul>
                              )}
                            </li>
                          )
                        })}
                      </ul>
                    </section>
                  )}
                </li>
              )
            })}
          <li className={styles.listExtra}>
            <ul>
              {siteSettings.linkLogin && (
                <IconLink
                  icon={iconUser}
                  href={siteSettings.linkLogin.url}
                  text={siteSettings.linkLogin.title}
                  internal={siteSettings.linkLogin.target !== "_blank"}
                />
              )}
              {siteSettings.linkShop && (
                <IconLink
                  icon={iconShop}
                  href={siteSettings.linkShop.url}
                  text={siteSettings.linkShop.title}
                  internal={siteSettings.linkShop.target !== "_blank"}
                  target={siteSettings.linkShop.target}
                />
              )}
            </ul>
          </li>
        </ul>
      </MotionBox>
    </div>
  )
}

Menu.propTypes = {
  menuItems: PropTypes.object,
}

Menu.defaultProps = {
  currentLanguage: `fi`,
  menuItems: ``,
}

export default Menu
